import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class NoteMatcherView extends PureComponent {
  static propTypes = {
    controller: PropTypes.object,
    currentTime: PropTypes.number,
    verbose: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      // zoom, moltiplicatore (compreso tra 1 e 10)
      zoom: 1,
      // offset in secondi di quanto saltare dall'inizio del brano.
      offset: 0
    };
    this.canvas = React.createRef();
    if (this.props.controller) this.props.controller.onNotesChanged = this.draw;
  }

  componentDidUpdate() {
    // TODO: fare solo se cambia controller
    if (this.props.controller) this.props.controller.onNotesChanged = this.draw;
  }

  fitToContainer() {
    const canvas = this.canvas.current;
    // Make it visually fill the positioned parent
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    // ...then set the internal size to match
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;
  }

  draw = () => {
    if (!this.props.controller) {
      return;
    }

    this.fitToContainer();

    const { controller, currentTime, verbose } = this.props;

    const canvas = this.canvas.current;
    const height = canvas.height;
    const width = canvas.width;
    const context = canvas.getContext('2d');
    // zoomed ref system:
    const { offset, zoom } = this.state;
    // in millisecondi.
    const wStart = controller.startTime + offset * 1000;
    const wEnd = wStart + (currentTime * 1000) / zoom;
    const wDuration = wEnd - wStart;
    if (verbose) {
      console.log('ZOOM:', zoom, 'OFFSET:', offset);
      console.log('Brano da', controller.startTime, 'a', currentTime);
      console.log('Vista da', wStart, 'a', wEnd, '->', wDuration);
    }

    // ripulisci tutto.
    context.clearRect(0, 0, width, height);
    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, width, height);
    //grid: linea orizzontale.
    context.lineWidth = 1;
    context.strokeStyle = '#AAAAAA';
    context.beginPath();
    context.moveTo(0, height / 2);
    context.lineTo(width, height / 2);
    context.stroke();
    //listened:
    let noteY = 0;
    let noteHeight = height / 2 - 20;

    // rettangoli di timestamp di sfondo
    context.fillStyle = '#CCCCCC';
    for (let i = 0; i < controller.playedNotes.length; i++) {
      const note = controller.playedNotes[i].note;
      const rectX = (width * (note.timestamp - controller.advance_tolerance - wStart)) / wDuration;
      const widthX = (width * (controller.advance_tolerance + controller.late_tolerance)) / wDuration;
      context.fillRect(rectX, 0, widthX, height);
      if (verbose) {
        console.log(note.timestamp, controller.advance_tolerance, offset, wStart, wDuration);
        console.log('fillrect:', rectX, widthX);
      }
    }

    // tempi:
    context.fillStyle = '#ff0000';
    context.font = '9px Arial';
    context.textAlign = 'start';
    // const stepWidth = 100;
    // const numberOfSteps = Math.floor(width / stepWidth);

    const numberOfSteps = 20;
    const stepWidth = width / numberOfSteps;
    for (let i = 0; i <= numberOfSteps; i++) {
      const timeText = (offset + (wDuration / 1000 / numberOfSteps) * i).toFixed(2);
      // tacche:
      if (i !== 0) {
        context.moveTo(stepWidth * i, 0);
        context.lineTo(stepWidth * i, height);
        context.stroke();
      }
      if (i === numberOfSteps) context.textAlign = 'end';
      else context.textAlign = 'start';
      if (verbose) {
        console.log('Disegna:', stepWidth * i, 'su', width, i);
        console.log('Tempo:', offset, wDuration, timeText);
      }
      // testo del tempo:
      context.fillText(timeText, stepWidth * i, height / 2 - 10);
    }

    context.lineWidth = 1;
    context.strokeStyle = '#000000';
    context.fillStyle = '#ff00ff';
    context.textAlign = 'start';
    let lastEqualNote = null;
    for (let i = 0; i < controller.listenedNotes.length; i++) {
      const { note, matches, checked, skipped, matches_extended, checked_extended } = controller.listenedNotes[i];
      // width : currentTime = noteX : note.timestamp
      const noteX = (width * (note.timestamp - wStart)) / wDuration;
      // width : currentTime = noteWidth : note.duration
      const noteWidth = (width * note.duration) / wDuration;

      if (matches) context.fillStyle = '#00ff00';
      else if (matches_extended) context.fillStyle = '#008800';
      else if (checked) context.fillStyle = '#ff00ff';
      else if (checked_extended) context.fillStyle = '#880088';
      else if (skipped) context.fillStyle = '#888888';
      else context.fillStyle = '#dbca02';
      context.fillRect(noteX + 1, noteY, noteWidth - 1, noteHeight);
      if (lastEqualNote === null || !lastEqualNote.equals(note)) {
        if (lastEqualNote !== null) {
          const previousNote = controller.listenedNotes[i - 1].note;

          const groupX = (width * (lastEqualNote.timestamp - wStart)) / wDuration;
          const prevX = (width * (previousNote.timestamp - wStart)) / wDuration;
          const prevWidth = (width * previousNote.duration) / wDuration;

          context.strokeRect(groupX + 1, noteY, prevX + prevWidth - groupX - 2, noteHeight / 2);
          context.fillStyle = '#000000';
          const textHeight = (i % 5) * (noteHeight / 5);
          context.fillText(lastEqualNote.traditionalName(), groupX + 1, 10 + textHeight);
        }
        lastEqualNote = note;
      }
    }
    //player:
    noteY = height / 2 + 10;
    noteHeight = height - noteY;
    for (let i = 0; i < controller.playedNotes.length; i++) {
      const note = controller.playedNotes[i].note;
      const { listenedFound } = controller.playedNotes[i];
      const noteX = (width * (note.timestamp - wStart)) / wDuration;
      const noteWidth = (width * note.duration) / wDuration;
      // NOTE RECT:
      if (listenedFound) context.fillStyle = '#f1d792';
      else context.fillStyle = '#ff0000';
      context.fillRect(noteX, noteY, noteWidth, noteHeight);
      context.strokeRect(noteX, noteY, noteWidth, noteHeight);
      // INFOS:
      const noteName = note.traditionalName();
      context.font = '9px Arial';
      context.textAlign = 'center';
      context.fillStyle = '#000000';
      context.fillText(noteName, noteX + noteWidth / 2, noteY + noteHeight / 2);
      context.fillText(Math.floor(note.duration) + ' msecs', noteX + noteWidth / 2, 10 + noteY + noteHeight / 2);
    }
  };

  zoomOut = () => {
    if (this.state.zoom > 1) {
      this.setState({ zoom: this.state.zoom - 1 }, this.draw);
    }
  };

  zoomIn = () => {
    if (this.state.zoom < 20) {
      this.setState({ zoom: this.state.zoom + 1 }, this.draw);
    }
  };

  moveLeft = () => {
    if (this.state.offset > 0) {
      this.setState({ offset: this.state.offset - 1 }, this.draw);
    }
  };

  moveRight = () => {
    if (this.state.offset < this.props.currentTime) {
      this.setState({ offset: this.state.offset + 1 }, this.draw);
    }
  };

  render() {
    const { zoom, offset } = this.state;
    return (
      <div>
        <canvas ref={this.canvas} />
        <button onClick={this.zoomOut}>-</button>
        {zoom}
        <button onClick={this.zoomIn}>+</button>
        <button onClick={this.moveLeft}>&lt;-</button>
        {offset}
        <button onClick={this.moveRight}>-&gt;</button>
      </div>
    );
  }
}

export default NoteMatcherView;
